import React, { useState } from "react";
import FilerobotImageEditor, { TABS, TOOLS } from "react-filerobot-image-editor";
import { Box, Button, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useImageContext } from "../context/ImageContext"; // Import context
import { Visibility, RocketLaunch, Share } from "@mui/icons-material"; // Import icons  

const DEFAULT_IMAGE = "/assets/canvas_placeholder.png"; // Set your default image path


function ImageEditorComponent() {
  const navigate = useNavigate();
  const { selectedImage } = useImageContext(); // Get image from context
  const [previewImage, setPreviewImage] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile

  const imageToEdit = selectedImage || DEFAULT_IMAGE; // Use selected image or fallback to default

  const handleSave = (editedImageObject) => {
    setPreviewImage(editedImageObject.imageBase64);
    setOpenPreview(true);
  };

  return (
    <div style={{ height: "85vh", width: "100%"}}>
      <FilerobotImageEditor
        source={imageToEdit}
        onSave={(editedImageObject, designState) =>
          console.log("Saved", editedImageObject, designState)
        }
        annotationsCommon={{ fill: "#ff0000" }}
        Text={{
          text: "Filerobot...",
          fonts: [
            "Arial",
            "Verdana",
            "Times New Roman",
            "Courier New",
            "Comic Sans MS",
            "Georgia",
            "Impact",
            "Tahoma",
            "Trebuchet MS",
            "Lucida Sans",
            "Poppins",
            "Roboto",
            "Lato",
            "Montserrat",
            "Open Sans",
          ],
        }}
        Rotate={{ angle: 90, componentType: "slider" }}
        Adjust={{ removeBackground: true }}
        tabsIds={[
          TABS.ADJUST,
          TABS.ANNOTATE,
          TABS.WATERMARK,
          TABS.RESIZE,
          TABS.CROP,
          TABS.FILTERS,
          TABS.FINE_TUNE,
          TABS.FOCUS_POINT,
        ]}
        defaultTabId={TABS.ANNOTATE}
        defaultToolId={TOOLS.TEXT}
        toolsIds={[
          TOOLS.TEXT,
          TOOLS.IMAGE,
          TOOLS.CROP,
          TOOLS.RESIZE,
          TOOLS.WATERMARK,
          TOOLS.DRAW,
          TOOLS.SHAPES,
          TOOLS.ICONS,
          TOOLS.BACKGROUND,
          TOOLS.REMOVE_BG,
        ]}
      />
    </div>
  );
}

export default ImageEditorComponent;
